import { find, omitBy, isNil, toUpper } from 'lodash';
import moment from 'moment';

import gender from 'Data/gender.json';
import idType from 'Data/id-type.json';

export default function serverData(data: any) {
  // const selectedGender = find(gender, (o) => { return toUpper(o.DESC) === data.gender })
  const selectedIdType = find(idType, (o) => {
    return toUpper(o.DESC.replace(' ', '_')) === data.idType
  })

  return omitBy({
    DisplayName: data.displayName || data.fullName,
    Name: data.fullName,
    IdType: selectedIdType!.ID,
    NRIC: data.idNumber,
    Email: (data.email as string).toLowerCase(),
    MobilePhone: data.mobilePhone.number,
    MobileTelArea: data.mobilePhone.dialCode,
    Password: data.password,
    PhotoData: data.photoData || '',
    PersonType: data.personType ? data.personType : '0',
    // Gender: selectedGender!.ID,
    // DateOfBirth: data.dob ? moment(data.dob, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DD') : null,
    // Race: { Code: data.race },
    // Religion: { Code: data.religion },
    // OriginCountry: data.originCountry,
    SupportingDocs:[
      {
        DataUrl:data.idImageData

    }],
    MailingAddress: omitBy({
      Address1: data.addressLine1,
      Address2: data.addressLine2,
      Address3: undefined,
      State: data.state ?
        {
          Code: data.state,
        } :
        undefined,
      Postcode: data.postcode,
      Country: data.country ? 
        {
          Code: data.country,
        } :
        undefined,
      City: data.city ? 
        {
          Code: data.city,
        } : 
        undefined,
    }, isNil),
  }, isNil)
}
